import React, { useState, useEffect } from "react";
import { useInput } from "react-admin";
import { TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import config from '../config.json';
import { stringify } from 'query-string';
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';

const DashboardTemplateSelector = (props) => {
    const { resourcePath, resourceParam, source, filter, style, ...rest } = props;
    const { input: { onChange } } = useInput(props);

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    // const fetchRoleTimeout = useRef(null);

    const getRoles = () => {
        var params = {
            user_id: sessionStorage.getItem("user_id"),
            filter: JSON.stringify({ [resourceParam ? resourceParam : source]: inputValue, ...filter })
        }
        fetch(`${config.HOST_NAME}/crm/${resourcePath}?${stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(responseJson => {
                if (responseJson.success) {
                    const filteredData = responseJson.data
                        .filter(category => {
                            const roles = JSON.parse(category.roles)
                            return roles[0].id !== null
                        })
                        .flatMap(category => {
                            const roles = JSON.parse(category.roles)
                            return [
                                { id: null, name: category.name, isCategory: true },
                                ...roles.map(role => ({
                                    groupName: category.name,
                                    id: role.id,
                                    name: role.name,
                                    isCategory: false
                                }))
                            ]
                        });
                    setOptions(filteredData);
                } else notify(responseJson.message, 'warning');
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
                notify('Error fetching data', 'warning');
                setLoading(false);
            });
    }

    useEffect(() => {
        getRoles();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //     if (fetchRoleTimeout.current)
    //         clearTimeout(fetchRoleTimeout.current);
    //     fetchRoleTimeout.current = setTimeout(getRoles, 500);
    // }, [inputValue]);

    return (
        <Autocomplete
            options={options}
            groupBy={(option) => option.isCategory ? option.name : option.groupName}
            getOptionLabel={(option) => !option.isCategory ? option.name : ""}
            filterOptions={(options, state) => options.filter(option => !option.isCategory)}
            renderInput={params => <TextField {...params} label="Select Dashboard Type" variant="outlined" size="small" />}
            onChange={(event, newValue) => {
                if (newValue) {
                    onChange(newValue.id)
                }
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            loading={loading}
            noOptionsText="No Records"
            style={style}
            {...rest}
        />
    );
};

export default DashboardTemplateSelector;
